import { EntitySectionLayout } from "@/shared/components/common/EntitySectionLayout";
import { InstitutionHeader } from "./InstitutionHeader";
import { INSTITUTION_LISTING_CONFIG } from "../constants/listingConfig";

export function InstitutionLayout() {
  return (
    <EntitySectionLayout
      basePath={INSTITUTION_LISTING_CONFIG.basePath}
      HeaderComponent={InstitutionHeader}
      hideHeaderMatchers={["add", "edit/", "admins"]}
    />
  );
}
